import { render, staticRenderFns } from "./BuyingTableDisplay.vue?vue&type=template&id=0c2f1ece&scoped=true"
import script from "./BuyingTableDisplay.vue?vue&type=script&lang=ts"
export * from "./BuyingTableDisplay.vue?vue&type=script&lang=ts"
import style0 from "./BuyingTableDisplay.vue?vue&type=style&index=0&id=0c2f1ece&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2f1ece",
  null
  
)

export default component.exports